import React, { useEffect } from 'react'
import { I18nProvider } from '@lingui/react';
import Layout from '../components/Layout.js';
import Seo from "../components/Seo.js";
import FAQSupport from '../components/FAQSupport.js';

import img from '../images/repat-home.png';
import { useIntl } from 'gatsby-plugin-intl';
import i18n from '../i18n.js';

const Support = () => {
  const intl = useIntl();

  useEffect(() => {
    i18n.activate(intl.locale);
  }, [intl.locale]);

  return (
    <div>
      <I18nProvider i18n={i18n}>
        <Layout locale={intl.locale}>
          <Seo
            lang={intl.locale}
            title="Support - FAQ App Repat"
            description="Support et foire aux questions pour l'application mobile Repat"
            image={img}
            robots="index"
          />
          <FAQSupport />
        </Layout>
      </I18nProvider>
    </div>
  )
}

export default Support;
